import { v4 } from "uuid";
import Vue from "@/libraries/vue";
import axios from "@/libraries/axios";
import swal from "@/libraries/sweetalert";
import { i18n } from "@/plugins/i18n";
import fileInput from "@/components/fileInput.vue";
import { API_URL } from "@/assets/js/utils";
import { error } from "@/assets/js/exceptions";
import localesStore from "@/store/locales";
import footprintsStore from "@/store/footprints";
export default Vue.extend({
    name: "New",
    components: {
        fileInput,
    },
    data() {
        return {
            rand: Math.random(),
        };
    },
    computed: {
        newFootprint() {
            return footprintsStore.new;
        },
        imgUrl() {
            const newFootprint = this.newFootprint;
            const rand = this.rand;
            if (!newFootprint.id)
                newFootprint.id = v4();
            return footprintsStore.image(newFootprint.id) + "?" + rand;
        },
    },
    methods: {
        async create() {
            const newFootprint = this.newFootprint;
            if (!newFootprint.name || !newFootprint.comment) {
                swal(i18n.t("") || "Datos insuficientes");
                return;
            }
            const req = API_URL + `/footprints`;
            const response = await axios.post(req, {
                name: newFootprint.name,
                comment: newFootprint.comment,
            });
            const footprint = response && response.data;
            if (!footprint) {
                return;
            }
            const id = footprint.id;
            if (!id) {
                error("!id");
                return;
            }
            this.$router.push(localesStore.localePath(`/${id}`));
        },
    },
});
